import { render, staticRenderFns } from "./Expandable.vue?vue&type=template&id=20058a8d&"
import script from "./Expandable.vue?vue&type=script&lang=ts&"
export * from "./Expandable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports